export default "__VITE_ASSET__17559743__"